import styled from 'styled-components';

export const Content = styled.div`
  h2 {
    font-size: 1.2rem;
    margin: 10px -1px 15px;

    :first-child {
      margin: -5px -1px 15px;
    }
  }
`;

export const Label = styled.label`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;

  p.fieldName {
    font-size: 0.9rem;
    font-weight: 700;
    color: #999;
    letter-spacing: -0.5px;
    padding-bottom: 8px;
  }

  p.days {
    font-size: 0.9rem;
    font-weight: 700;
    color: #999;
    letter-spacing: -0.5px;
    padding: 38px 0 25px;
    text-align: right;
  }

  .checkbox {
    margin: 0;
    margin-left: 0 !important;
    padding-bottom: 20px;
  }

  @media screen and (min-width: 769px) {
    .checkbox {
      margin: 0;
      margin-left: 0 !important;
      padding: 37px 0 22px;
    }
  }

  @media screen and (max-width: 768px) {
    p.days {
      padding: 0;
      padding-bottom: 5px;
      color: #000;
      text-align: left;
    }
  }
`;
